// Les pastilles proposées sous le champ de recherche, tant que rien n'est
// tapé. Extraites de Services.jsx pour que le test puisse les rejouer une à
// une contre le catalogue : deux d'entre elles — « Rituel » et « Minceur » —
// ne renvoyaient aucun résultat, le site invitait donc à cliquer sur ses
// propres impasses (#97).
//
// Ajouter une suggestion ici la place SOUS ce test : une pastille qui ne mène
// à rien fait échouer la suite, avant d'atteindre le site.
export const SUGGESTIONS = ['Hammam', 'Cils', 'Rituel', 'Minceur', 'Maillot', 'Vernis']
